if (!customElements.get('fills-buybox')) {
  customElements.define('fills-buybox', class FillsBuybox extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const dataEl = this.querySelector('[data-fills-data]');
      if (!dataEl || !window.FillsOffer) return;
      this.config = JSON.parse(dataEl.textContent);
      this.initialized = true;
      this.variants = this.config.variants || [];
      this.strings = this.config.strings;
      this.state = { sabor: this.config.defaultSabor, bottles: 1, purchase: 'subscribe' };
      this.form = this.querySelector('form[data-type="add-to-cart-form"]');
      this.submitBtn = this.form?.querySelector('[type="submit"]');
      this.submitText = this.submitBtn?.querySelector('[data-add-text]');
      this.saborInputs = this.querySelectorAll('[data-sabor-input]');
      this.gallery = this.querySelector('fills-product-gallery');
      this.saborInputs.forEach((input) => input.addEventListener('change', () => {
        this.state.sabor = input.value;
        if (input.dataset.accent) this.style.setProperty('--flavor-accent', input.dataset.accent);
        if (input.dataset.deep) this.style.setProperty('--flavor-deep', input.dataset.deep);
        if (input.dataset.text) this.style.setProperty('--flavor-text', input.dataset.text);
        this.filterGallery();
        this.emitFlavor(input);
        this.syncUrl();
        this.render();
      }));
      this.querySelectorAll('[data-oa-mode]').forEach((input) => input.addEventListener('change', () => {
        this.state.purchase = input.value;
        this.render();
      }));
      if (this.form) this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.addSelection();
      }, true);
      this.querySelector('[data-sticky-add]')?.addEventListener('click', () => {
        if (this.config.preorder) {
          const target = this.querySelector('[data-purchase-block]');
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target?.scrollIntoView({ behavior: reduced ? 'instant' : 'smooth', block: 'center' });
          this.querySelector('[data-notify-form]:not([hidden]) input')?.focus({ preventScroll: true });
        } else this.submitBtn?.click();
      });
      this.bindNotify();
      this.observeSticky();
      this.render();
      this.filterGallery();
      this.emitFlavor(this.querySelector('[data-sabor-input]:checked'));
      this.classList.add('is-ready');
    }

    currentVariant() {
      return this.variants.find((variant) => variant.sabor === this.state.sabor);
    }

    amount(template, amount) {
      return template.replace('__AMOUNT__', this.money(amount));
    }

    money(cents) {
      return '$' + (cents / 100).toLocaleString('es-MX', { maximumFractionDigits: 2 });
    }

    render() {
      const offer = window.FillsOffer.quote(this.config, this.state);
      if (!offer) return;
      const prices = this.config.prices[this.state.bottles];
      const onetimeTotal = prices.onetime + prices.shipping;
      const saving = prices.onetime - prices.subscribe;
      const set = (selector, text) => {
        const element = this.querySelector(selector);
        if (element) element.textContent = text;
      };
      set('[data-oa-price-ot]', this.money(prices.onetime));
      set('[data-oa-price-sub]', this.money(prices.subscribe));
      set('[data-oa-ot-shipping]', prices.shipping ? this.amount(this.strings.shippingExtra, prices.shipping) : this.strings.freeShipping);
      set('[data-oa-ot-total]', this.amount(this.strings.deliveredTotal, onetimeTotal));
      set('[data-oa-sub-saving]', this.amount(this.strings.productSaving, saving));
      set('[data-oa-saving-percent]', this.strings.savingPercent.replace('__PERCENT__', Math.floor(saving * 100 / prices.onetime)));
      set('[data-oa-frequency]', this.strings.frequencyOne);
      const flavors = this.state.sabor;
      const subscribing = this.state.purchase === 'subscribe';
      const mode = subscribing ? this.strings.subscribeMonthly : this.strings.onetime;
      const quantityText = this.strings.oneBottle;
      set('[data-oa-summary]', this.strings.summary.replace('__QUANTITY__', quantityText).replace('__FLAVORS__', flavors).replace('__MODE__', mode).replace('__TOTAL__', this.money(offer.total)));
      const canPurchase = !!window.FillsOffer.items(this.config, this.state);
      if (this.submitBtn) {
        this.submitBtn.disabled = !canPurchase || !!this.busy;
        this.submitBtn.setAttribute('aria-disabled', String(this.submitBtn.disabled));
        if (this.submitText) this.submitText.textContent = canPurchase ? this.strings.add + ' · ' + this.money(offer.total) : this.strings.unavailable;
      }
      const sticky = this.querySelector('[data-sticky-add]');
      if (sticky) sticky.disabled = !this.config.preorder && (!canPurchase || !!this.busy);
      set('[data-overview-price]', this.money(offer.total) + (subscribing ? this.strings.perMonth : ''));
      set('[data-overview-selection]', quantityText + ' · ' + mode);
      set('[data-overview-note]', offer.shipping ? this.amount(this.strings.shippingIncluded, offer.shipping) : this.strings.totalIncluded);
      set('[data-sticky-quantity]', quantityText);
      set('[data-sticky-price]', this.money(offer.total) + (subscribing ? this.strings.perMonth : ''));
      set('[data-sticky-flavor]', flavors);
      set('[data-sticky-sub]', mode);
    }

    async addSelection() {
      if (this.busy) return;
      const items = window.FillsOffer.items(this.config, this.state);
      if (!items) return;
      this.busy = true;
      this.render();
      const wrapper = this.querySelector('.product-form__error-message-wrapper');
      const error = wrapper?.querySelector('.product-form__error-message');
      if (wrapper) wrapper.hidden = true;
      const drawer = document.querySelector('cart-drawer');
      drawer?.setActiveElement(document.activeElement);
      this.submitBtn?.classList.add('loading');
      try {
        const addRoute = window.routes?.cart_add_url || '/cart/add';
        const response = await fetch(addRoute.endsWith('.js') ? addRoute : addRoute + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: drawer?.getSectionsToRender().map((section) => section.id) || [], sections_url: window.location.pathname }),
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || this.strings.error);
        if (drawer && data.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        } else {
          window.location.assign(window.routes?.cart_url || '/cart');
        }
      } catch (err) {
        if (wrapper) wrapper.hidden = false;
        if (error) error.textContent = err.message || this.strings.error;
      } finally {
        this.busy = false;
        this.submitBtn?.classList.remove('loading');
        this.render();
      }
    }

      bindNotify() {
        const form = this.querySelector('[data-notify-form]');
        if (!form) return;
        const company = form.dataset.klCompany;
        const list = form.dataset.klList;
        const msg = this.querySelector('[data-notify-msg]');
        const btn = form.querySelector('[data-notify-submit]');
        const say = (text, ok) => {
          if (!msg) return;
          msg.textContent = text;
          msg.hidden = false;
          msg.classList.toggle('is-error', !ok);
        };
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          const email = (form.email && form.email.value || '').trim();
          if (!email || !company || !list) { say('Escribe un correo válido.', false); return; }
          if (btn) btn.disabled = true;
          form.classList.add('is-loading');
          try {
            const res = await fetch(
              'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company),
              {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
                body: JSON.stringify({
                  data: {
                    type: 'subscription',
                    attributes: {
                      custom_source: 'Preventa PDP',
                      profile: {
                        data: {
                          type: 'profile',
                          attributes: {
                            email: email,
                            properties: { 'Sabor de interés': this.state.sabor, Origen: 'Preventa PDP' },
                          },
                        },
                      },
                    },
                    relationships: { list: { data: { type: 'list', id: list } } },
                  },
                }),
              }
            );
            if (res.ok || res.status === 202) {
              form.hidden = true;
              say(form.dataset.klSuccess || '¡Listo! Te avisaremos.', true);
            } else {
              throw new Error('http ' + res.status);
            }
          } catch (err) {
            if (btn) btn.disabled = false;
            say('No se pudo registrar. Inténtalo de nuevo.', false);
          } finally {
            form.classList.remove('is-loading');
          }
        });
      }

      emitFlavor(el) {
        const detail = {
          sabor: this.state.sabor,
          accent: (el && el.dataset.accent) || '',
          deep: (el && el.dataset.deep) || '',
          text: (el && el.dataset.text) || '',
        };
        document.documentElement.setAttribute('data-fills-flavor', this.state.sabor);
        document.dispatchEvent(new CustomEvent('fills:flavor', { detail }));
      }

      observeSticky() {
        const sticky = this.querySelector('[data-sticky-bar]');
        const target = this.querySelector('[data-purchase-block]');
        if (!sticky || !target) return;
        this.updateSticky = () => {
          if (this.stickyFrame) return;
          this.stickyFrame = requestAnimationFrame(() => {
            this.stickyFrame = null;
            const show = window.matchMedia('(max-width: 989px)').matches && target.getBoundingClientRect().bottom <= 0;
            sticky.classList.toggle('is-visible', show);
            sticky.inert = !show;
          });
        };
        window.addEventListener('scroll', this.updateSticky, { passive: true });
        window.addEventListener('resize', this.updateSticky, { passive: true });
        this.updateSticky();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.updateSticky);
        window.removeEventListener('resize', this.updateSticky);
        if (this.stickyFrame) cancelAnimationFrame(this.stickyFrame);
      }

      filterGallery() {
        this.gallery?.setFlavor?.(this.state.sabor);
        this.querySelectorAll('[data-pack-img]').forEach((img) => {
          img.hidden = img.dataset.flavor !== this.state.sabor;
        });
      }

      syncUrl() {
        const v = this.currentVariant();
        if (!v || !window.history || !window.history.replaceState) return;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
  });
}

if (!customElements.get('fills-flavor-media')) {
  customElements.define(
    'fills-flavor-media',
    class FillsFlavorMedia extends HTMLElement {
      connectedCallback() {
        this.imgs = this.querySelectorAll('[data-flavor]');
        this.fallback = this.getAttribute('data-default') || '';
        this.onFlavor = (e) => this.apply(e.detail && e.detail.sabor);
        document.addEventListener('fills:flavor', this.onFlavor);
        this.apply(document.documentElement.getAttribute('data-fills-flavor') || this.fallback);
      }
      disconnectedCallback() {
        document.removeEventListener('fills:flavor', this.onFlavor);
      }
      apply(sabor) {
        if (!this.imgs || !this.imgs.length) return;
        let matched = false;
        this.imgs.forEach((img) => {
          const on = img.dataset.flavor === sabor;
          img.hidden = !on;
          if (on) matched = true;
        });
        // Sabor desconocido → cae al default para no ocultar todo.
        if (!matched) {
          this.imgs.forEach((img) => {
            img.hidden = img.dataset.flavor !== this.fallback;
          });
        }
      }
    }
  );
}
